module.exports = __webpack_public_path__ + "static/media/pharmacy1.cf64b952.jpg";